import { Observable } from 'rxjs';

import { Cell, CellType } from '../_base/table-cell.entity';

export class AsyncTextCell<T> extends Cell {
    constructor(
        public readonly asyncData: Observable<T>,
        public readonly stringFactory: (data: T) => string,
        public readonly placeholder: string,
        public readonly wrapText: boolean = true
    ) {
        super(CellType.ASYNC_TEXT);
    }
}
